export const constants = {
  logo:
    "https://uploads-ssl.webflow.com/5d9f64ed50ffcbe80454e690/5dcecaff792b967d45b7f878_2gethr-logo.svg",
  defaultAvatar:
    "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  preSpocConfirmation:
    "https://2gethrteam.s3.ap-south-1.amazonaws.com/admin-web-assets/preSpoc-Confirmation.svg",
  postSpocConfirmation:
    "https://2gethrteam.s3.ap-south-1.amazonaws.com/admin-web-assets/postSpoc-Confirmation.svg",
  sidebarMenu: {
    membership: {
      icon: "MdCardGiftcard",
      children: [
        {
          name: "View Membership",
          url: "/view-membership",
        },
        {
          name: "Add Organisation",
          url: "/add-organisation",
        },
        {
          name: "Add Membership",
          url: "/add-membership",
        },
        {
          name: "Update Membership",
          url: "/update-membership",
        },
      ],
    },
    invoices: {
      icon: "MdCardGiftcard",
      children: [
        {
          name: "View Invoices",
          url: "/invoices",
        },
        {
          name: "Create AdHOC Invoice",
          url: "/create-adhocInvoice",
        },
      ],
    },
    events: {
      icon: "MdCardGiftcard",
      children: [
        {
          name: "Event Dashboard",
          url: "/events",
        },
        {
          name: "Add Event",
          url: "/add-event",
        },
      ],
    },
    bookings: {
      icon: "MdCollectionsBookmark",
      children: [
        {
          name: "Bookings by a Membership.",
          url: "/bookings"
        },
        {
          name: "Bookings by a User.",
          url: "/bookings/user-bookings"
        },
        {
          name: "Bookings for a Conference Room.",
          url: "/bookings/room-wise-bookings"
        }
      ]
    },
    activities: {
      icon: "MdNotifications",
      children: [
        { name: "All Activity Logs", url: "/all-activityLogs" },
        // { name: "Material Table", url: "/adv-materialTable" },
        // { name: "Membership Activities", url: "/membership-activities" },
      ],
    },
    profile: {
      children: [
        { name: "Log Out", url: "/logout" },
      ],
    }
  },
};
